import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43a5b022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-8 line-account-toolbar text-right" }


import { SupportStatusEnum } from "@/clinic/typings/enums/line-account";
import Button from "primevue/button";
import { useChangeCase } from "@vueuse/integrations/useChangeCase";
import { get } from "@vueuse/core";

type ISupportStatusToolbar = {
  accountId: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'support-status-toolbar',
  props: {
    accountId: null
  },
  emits: ["click", "toggleSearchInput"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  accountId: number;
};





const onClick = (status: string) => emits("click", status, props.accountId);
const toggleSearchInput = () => emits("toggleSearchInput");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(SupportStatusEnum)), ([status, name]) => {
      return (_openBlock(), _createBlock(_unref(Button), {
        key: status,
        class: _normalizeClass(["ml-2 h-2rem p-button-outlined p-support-status", _unref(get)(_unref(useChangeCase)(status || '', 'snakeCase', { delimiter: '-' }))]),
        label: name,
        onClick: ($event: any) => (onClick(status))
      }, null, 8, ["class", "label", "onClick"]))
    }), 128)),
    _createVNode(_unref(Button), {
      class: "ml-2 h-2rem p-button-outlined p-search",
      icon: "pi pi-search",
      label: "検索",
      onClick: toggleSearchInput
    })
  ]))
}
}

})